import * as React from 'react';

import { HeadProps, PageProps } from 'gatsby';
import styled from 'styled-components';

import CaseStudyDetailComponent from 'stile-shared/src/components/2024/common/CaseStudies/CaseStudyDetailComponent';
import { CaseStudyWithImageData } from 'stile-shared/src/utils/case-studies';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

export function Head({ pageContext }: HeadProps<unknown, ContextProps>) {
  const { caseStudy } = pageContext;
  if (!caseStudy) return null;

  return (
    <SEO
      slug={`/why-choose-stile/case-studies/${caseStudy.slug}`}
      description={caseStudy.description}
      title={caseStudy.title}
      opengraphTitle={caseStudy.title}
      opengraphDescription={caseStudy.description}
    />
  );
}

const CaseStudyDetailPageLayout = styled(PageLayout)`
  .main-content {
    background-color: rgba(255, 255, 255, 0) !important;
    margin: 0;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
    }
  }
  @media (max-width: 768px) {
    .header-wrapper {
      background-color: var(--stile-green-2) !important;
    }
  }
  .content,
  .section {
    padding-top: 0 !important;
  }
`;

interface ContextProps {
  caseStudy: CaseStudyWithImageData;
  allCaseStudies: CaseStudyWithImageData[];
}
export default function CaseStudyDetailPage({
  pageContext,
  ...props
}: PageProps<never, ContextProps>) {
  const { caseStudy, allCaseStudies } = pageContext;

  return (
    <CaseStudyDetailPageLayout {...props}>
      {caseStudy && (
        <CaseStudyDetailComponent caseStudy={caseStudy} allCaseStudies={allCaseStudies} />
      )}
    </CaseStudyDetailPageLayout>
  );
}
